import { ReactNode } from "react";
import { classNames } from "primereact/utils";
import styles from "./WizardStep.module.scss";

interface IWizardStepProps {
  children: ReactNode;
  className?: string;
  isActive?: boolean;
  isEntering?: boolean;
  isExiting?: boolean;
  animationDelay?: number;
}

export const WizardStep = ({
  children,
  className,
  isActive = false,
  isEntering = false,
  isExiting = false,
  animationDelay = 0,
}: IWizardStepProps) => {
  return (
    <div
      className={classNames(styles.step, className, {
        [styles.active]: isActive,
        [styles.entering]: isEntering,
        [styles.exiting]: isExiting,
      })}
      style={{
        animationDelay: `${animationDelay}ms`,
      }}
    >
      <div className={styles.stepContent}>
        {children}
      </div>
    </div>
  );
};